module.exports = __webpack_public_path__ + "static/img/badge-ios.5326e91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/apps/badge-ios.jpg
// module id = bwXY
// module chunks = 1